export var OF_STRING = "of";
export var TO_STRING = "to";
export var GO_STRING = "Go";
export var GO_TO_PAGE_STRING = "Go to page";
export var DESKTOP_MIN_WIDTH = 768;
export var MOBILE_MAX_WIDTH = DESKTOP_MIN_WIDTH + 1;